import { apiSlice } from './apiSlice';
import { NotificationActions } from './notificationSlice';

export const implementerInboxSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getImplementerInbox: builder.query({
            query: ({filter}) => ({
                url: '/implementerReviews?filter=' + filter,
                method: 'GET',
            }),
            providesTags: (result = [], error, arg) => [
                { type: 'ImplementerDrafts', id: 'LIST' },
                ...result.map(({ id }) => ({ type: 'ImplementerDrafts', id })),
            ],
            async onQueryStarted({}, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(NotificationActions.addErrorNotification({
                        message: 'Failed to load implementer inbox. Please try again later.',
                        type: 'error',
                    }));
                }
            }
        }),
        getDraft: builder.query({
            query: (id) => ({
                url: '/drafts/' + id + '/staffReview',
                method: 'GET',
            }),
            providesTags: ['Draft'],
            async onQueryStarted({}, { dispatch, queryFulfilled }) {
                try {
                    await queryFulfilled;
                } catch (error) {
                    dispatch(NotificationActions.addErrorNotification({
                        message: 'Failed to load card for review. Please try again later.',
                        type: 'error',
                    }));
                }
            }
        }),
        updateDraft: builder.mutation({
            query: ({ draftId, status }) => ({
                url: `/drafts/${draftId}`,
                method: 'PATCH',
                body: {
                    status: status,
                    staff_review_completion_time: new Date().toISOString()
                }
            }),
            async onQueryStarted({ draftId, status }, { dispatch, queryFulfilled }) {
                try {
                    const { data: updatedDraft } = await queryFulfilled;
                    dispatch(apiSlice.util.updateQueryData('getDraft', draftId, draft => {
                        Object.assign(draft, updatedDraft);
                    }));
                    dispatch(NotificationActions.addSuccessNotification({
                        message: 'Review changes submitted successfully.'
                    }));
                } catch (error) {
                    dispatch(NotificationActions.addErrorNotification({
                        message: 'Could not submit changes at this time. Please try again later.'
                    }));
                }
            },
            invalidatesTags: (result, error, { draftId }) => [{ type: 'ImplementerDrafts', id: draftId }]
        }),
        updateImplementerReview: builder.mutation({
            query: ({ review, draftId, recommendation, newStatus, notes }) => ({
                url: `/staffReviews/${review.id}`,
                method: 'PATCH',
                body: {
                    status: newStatus,
                    notes: notes,
                }
            }),
            async onQueryStarted({ review, draftId, recommendation, newStatus, notes }, { dispatch, queryFulfilled, queryRejected }) {
                try {
                    const { data: updatedReview } = await queryFulfilled;
                    dispatch(apiSlice.util.updateQueryData('getDraft', draftId, draft => {
                        let existingRecIndex = draft.recommendations[recommendation.item.category].find((rec) => rec.id === recommendation.id);
                        if (existingRecIndex) {
                            Object.assign(existingRecIndex.implementer_review, updatedReview);
                        }
                    }));
                    dispatch(NotificationActions.addSuccessNotification({
                        message: 'Review updated successfully.'
                    }));
                } catch (error) {
                    if (error.status === 403) {
                        dispatch(NotificationActions.addErrorNotification({
                            message: 'You do not currently have permission to update this review.'
                        }));
                    } else {
                        dispatch(NotificationActions.addErrorNotification({
                            message: 'Could not submit review at this time. Please try again later.'
                        }));
                    }
                }
            },
            invalidatesTags: (result, error, { draftId }) => [
                { type: 'ImplementerDrafts', id: 'LIST' },
                { type: 'ImplementerDrafts', id: draftId }
            ]
        }),
        createDraftCheckoutLog: builder.mutation({
            query: ({ draftId, action, reason }) => ({
                url: `/drafts/${draftId}/checkoutLogs`,
                method: 'POST',
                body: {
                    action: action,
                    reason: reason,
                }
            })
        }),
    })
});

export const {
    useGetImplementerInboxQuery,
    useGetDraftQuery,
    useUpdateDraftMutation,
    useUpdateImplementerReviewMutation,
    useCreateDraftCheckoutLogMutation,
} = implementerInboxSlice;
